export default __webpack_public_path__ + "static/media/google authenticator.8a3c21c3.png";